// test868
(868 && 0);
